export default function PrivacyPage() {
  return (
    <div className="min-h-screen pt-24" data-testid="privacy-page">
      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-[#FAFAF5]">
        <div className="container mx-auto px-4 md:px-8 max-w-4xl">
          <div
            
            
            
            className="text-center"
          >
            <p className="text-xs tracking-[0.2em] text-neutral-500 uppercase mb-4">Legal</p>
            <h1 className="font-serif text-5xl md:text-6xl font-bold text-black mb-6">
              Privacy <span className="italic">Policy</span>
            </h1>
            <p className="text-neutral-600">
              Last updated: February 2024
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 md:px-8 max-w-4xl">
          <div className="prose prose-lg max-w-none">
            
            {/* Introduction */}
            <div
              
              
              
              className="mb-12"
            >
              <h2 className="font-serif text-2xl font-semibold text-black mb-4">Introduction</h2>
              <p className="text-neutral-600 leading-relaxed mb-4">
                Honey I'm Home Coffee ("we", "our", or "us") is committed to protecting your privacy. 
                This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
                when you visit our website, make a reservation, or interact with us in any way.
              </p>
              <p className="text-neutral-600 leading-relaxed">
                Please read this privacy policy carefully. If you do not agree with the terms of this 
                privacy policy, please do not access the site.
              </p>
            </div>

            {/* Information We Collect */}
            <div
              
              
              
              className="mb-12"
            >
              <h2 className="font-serif text-2xl font-semibold text-black mb-4">Information We Collect</h2>
              <p className="text-neutral-600 leading-relaxed mb-4">
                We may collect information about you in a variety of ways. The information we may collect includes:
              </p>
              
              <h3 className="font-semibold text-black mt-6 mb-3">Personal Data</h3>
              <p className="text-neutral-600 leading-relaxed mb-4">
                Personally identifiable information, such as your name, email address, telephone number, 
                and other data you voluntarily give to us when you:
              </p>
              <ul className="list-disc list-inside text-neutral-600 space-y-2 mb-4">
                <li>Make a table reservation</li>
                <li>Submit a contact form enquiry</li>
                <li>Subscribe to our newsletter</li>
                <li>Apply for franchise opportunities</li>
                <li>Interact with us on social media</li>
              </ul>

              <h3 className="font-semibold text-black mt-6 mb-3">Automatically Collected Information</h3>
              <p className="text-neutral-600 leading-relaxed">
                When you visit our website, we may automatically collect certain information about your 
                device, including your IP address, browser type, operating system, access times, and 
                the pages you have viewed. This information is used for analytics purposes to improve 
                our website and services.
              </p>
            </div>

            {/* How We Use Your Information */}
            <div
              
              
              
              className="mb-12"
            >
              <h2 className="font-serif text-2xl font-semibold text-black mb-4">How We Use Your Information</h2>
              <p className="text-neutral-600 leading-relaxed mb-4">
                We use the information we collect for various purposes, including to:
              </p>
              <ul className="list-disc list-inside text-neutral-600 space-y-2">
                <li>Process and manage your reservations</li>
                <li>Respond to your enquiries and provide customer support</li>
                <li>Send you promotional communications (with your consent)</li>
                <li>Improve our website, products, and services</li>
                <li>Process franchise applications</li>
                <li>Comply with legal obligations</li>
                <li>Protect against fraudulent or illegal activity</li>
              </ul>
            </div>

            {/* Data Retention */}
            <div
              
              
              
              className="mb-12"
            >
              <h2 className="font-serif text-2xl font-semibold text-black mb-4">Data Retention</h2>
              <p className="text-neutral-600 leading-relaxed">
                We will retain your personal data only for as long as is necessary for the purposes 
                set out in this Privacy Policy. We will retain and use your data to the extent necessary 
                to comply with our legal obligations, resolve disputes, and enforce our policies.
              </p>
            </div>

            {/* Sharing Your Information */}
            <div
              
              
              
              className="mb-12"
            >
              <h2 className="font-serif text-2xl font-semibold text-black mb-4">Sharing Your Information</h2>
              <p className="text-neutral-600 leading-relaxed mb-4">
                We do not sell, trade, or rent your personal information to third parties. We may share 
                your information in the following situations:
              </p>
              <ul className="list-disc list-inside text-neutral-600 space-y-2">
                <li><strong>Service Providers:</strong> We may share your information with third-party vendors 
                who perform services on our behalf (e.g., email delivery, hosting).</li>
                <li><strong>Legal Requirements:</strong> We may disclose your information if required by law 
                or in response to valid requests by public authorities.</li>
                <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, 
                your information may be transferred.</li>
              </ul>
            </div>

            {/* Your Rights */}
            <div
              
              
              
              className="mb-12"
            >
              <h2 className="font-serif text-2xl font-semibold text-black mb-4">Your Rights</h2>
              <p className="text-neutral-600 leading-relaxed mb-4">
                Under UK GDPR, you have the following rights regarding your personal data:
              </p>
              <ul className="list-disc list-inside text-neutral-600 space-y-2">
                <li><strong>Right of Access:</strong> Request copies of your personal data</li>
                <li><strong>Right to Rectification:</strong> Request correction of inaccurate data</li>
                <li><strong>Right to Erasure:</strong> Request deletion of your data</li>
                <li><strong>Right to Restrict Processing:</strong> Request limitation of data processing</li>
                <li><strong>Right to Data Portability:</strong> Request transfer of your data</li>
                <li><strong>Right to Object:</strong> Object to certain types of processing</li>
              </ul>
              <p className="text-neutral-600 leading-relaxed mt-4">
                To exercise any of these rights, please contact us using the details provided below.
              </p>
            </div>

            {/* Cookies */}
            <div
              
              
              
              className="mb-12"
            >
              <h2 className="font-serif text-2xl font-semibold text-black mb-4">Cookies</h2>
              <p className="text-neutral-600 leading-relaxed">
                Our website may use cookies to enhance your experience. Cookies are small files that 
                a site or its service provider transfers to your device through your web browser. 
                You can choose to have your computer warn you each time a cookie is being sent, 
                or you can choose to turn off all cookies through your browser settings.
              </p>
            </div>

            {/* Security */}
            <div
              
              
              
              className="mb-12"
            >
              <h2 className="font-serif text-2xl font-semibold text-black mb-4">Security</h2>
              <p className="text-neutral-600 leading-relaxed">
                We use administrative, technical, and physical security measures to help protect your 
                personal information. While we have taken reasonable steps to secure the personal 
                information you provide to us, please be aware that no method of transmission over 
                the Internet is 100% secure.
              </p>
            </div>

            {/* Contact Us */}
            <div
              
              
              
              className="mb-12"
            >
              <h2 className="font-serif text-2xl font-semibold text-black mb-4">Contact Us</h2>
              <p className="text-neutral-600 leading-relaxed mb-4">
                If you have questions or comments about this Privacy Policy, please contact us at:
              </p>
              <div className="bg-[#FAFAF5] p-6">
                <p className="text-neutral-700 font-medium mb-2">Honey I'm Home Coffee</p>
                <p className="text-neutral-600 text-sm mb-1">451 High Road</p>
                <p className="text-neutral-600 text-sm mb-1">Woodford Green, London IG8 0XE</p>
                <p className="text-neutral-600 text-sm mb-1">
                  Email: <a href="mailto:Enquiries@honeyimhomecoffee.com" className="text-black underline">
                    Enquiries@honeyimhomecoffee.com
                  </a>
                </p>
                <p className="text-neutral-600 text-sm">
                  Phone: <a href="tel:+447739083131" className="text-black underline">+44 7739 083131</a>
                </p>
              </div>
            </div>

            {/* Changes to Policy */}
            <div
              
              
              
            >
              <h2 className="font-serif text-2xl font-semibold text-black mb-4">Changes to This Policy</h2>
              <p className="text-neutral-600 leading-relaxed">
                We may update this Privacy Policy from time to time. We will notify you of any changes 
                by posting the new Privacy Policy on this page and updating the "Last updated" date. 
                You are advised to review this Privacy Policy periodically for any changes.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}
